/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareRightIcon20Solid = forwardRef('ArrowFigureASquareRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 2a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4H6Zm4.251 4.293a.9.9 0 0 0 .062 1.271L12.006 9.1H6a.9.9 0 1 0 0 1.8h6.006l-1.693 1.536a.9.9 0 0 0 1.21 1.333l2.602-2.362a1.9 1.9 0 0 0 0-2.814L11.523 6.23a.9.9 0 0 0-1.272.062Z" })));
});
